import { isValid, parseISO } from "date-fns";

type DateInput = unknown;

const TR_LOCALE = "tr-TR";

const LONG_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "long",
  year: "numeric",
};

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

const DOT_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

function toDate(value: DateInput): Date | null {
  if (value === null || value === undefined) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (typeof value !== "string") return null;

  const normalized = value.trim();
  if (!normalized) return null;

  const isoDate = parseISO(normalized);
  if (isValid(isoDate)) return isoDate;

  const fallbackDate = new Date(normalized);
  return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
}

export function formatDateTR(
  value: DateInput,
  options?: Intl.DateTimeFormatOptions,
  fallback = "-",
): string {
  const date = toDate(value);
  if (!date) return fallback;
  return date.toLocaleDateString(TR_LOCALE, options);
}

export function formatDateTRShort(
  value: DateInput,
  fallback = "-",
): string {
  return formatDateTR(value, DOT_DATE_OPTIONS, fallback);
}

export function formatDateTRLong(
  value: DateInput,
  fallback = "-",
): string {
  return formatDateTR(value, LONG_DATE_OPTIONS, fallback);
}

export function formatDateTimeTR(
  value: DateInput,
  fallback = "-",
): string {
  const date = toDate(value);
  if (!date) return fallback;
  return date.toLocaleString(TR_LOCALE, DATE_TIME_OPTIONS);
}

export function getPreviousMonthKey(referenceDate = new Date()): string {
  const date = new Date(referenceDate.getFullYear(), referenceDate.getMonth() - 1, 1);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}
